/**
 * Tipos da visão administrativa (Onda 2 / A05).
 *
 * Ficam num arquivo próprio — e não em `types/dashboard.ts` — porque o
 * `DashboardResumo` é consumido pelo Dashboard do consultor (A04, em paralelo
 * nesta rodada): estender aqui evita duas mãos no mesmo arquivo. Os campos
 * espelham o `DashboardResumoResponse` estendido pelo A03.
 */
import { DashboardResumo } from '@/types/dashboard'

/**
 * Status da Defesa de Crédito (Onda 4 / A08, V41) — espelho de `StatusDefesa.java`.
 * Nulo na reserva = defesa ainda não iniciada.
 */
export type StatusDefesa = 'MINUTA' | 'EM_REVISAO' | 'APROVADA'

/** Rótulos do Figma (28:130): "Em preparação / Revisar minuta / Aguardando". */
export const STATUS_DEFESA_LABEL: Record<StatusDefesa, string> = {
  MINUTA: 'Em preparação',
  EM_REVISAO: 'Revisar minuta',
  APROVADA: 'Aprovada',
}

/**
 * Uma linha da comparação entre consultores (Figma 6:2). Vem no
 * `/v1/dashboard/resumo` SÓ para ADMIN/GERENTE (campo omitido para os demais).
 *
 * `nome` é SEMPRE nulo por enquanto: o módulo de oportunidades não guarda nome
 * de usuário (fica no Keycloak) — a tela mostra o id truncado, nunca inventa.
 * `canal` nulo = reservas do consultor com mais de um canal (histórico anterior
 * ao carimbo, transferência) — "misto/sem carimbo".
 */
export interface ConsultorComparativo {
  consultorId: string
  nome: string | null
  canal: string | null
  volume: number
  /** Conversão em % (uma casa), calculada no backend sobre a mesma lista. */
  conversao: number
  pendencias: number
}

/**
 * `DashboardResumo` + os campos que o A03 acrescentou (Onda 2). Opcionais para
 * conviver com respostas de backend anterior durante o rollout.
 */
export interface DashboardResumoAdmin extends DashboardResumo {
  /** Conversão do recorte em % (uma casa) — ganhas ÷ total da mesma lista. */
  conversao?: number | null
  /** Presente só para ADMIN/GERENTE; omitido (nunca lista vazia) para os demais. */
  porConsultor?: ConsultorComparativo[]
}

/**
 * Cabeçalho do checklist documental da reserva (`GET /v1/oportunidades/{id}/checklist`,
 * Onda 4 / A08) — só o que a coluna "Documentação %" precisa; os grupos por
 * categoria ficam para o workspace do consultor (A09).
 */
export interface ChecklistReserva {
  total: number
  presentes: number
  /** 0–100, arredondado no backend; 100 quando não há exigência. */
  percentual: number
}
